import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  return (
    <section id="guida" className="py-16 md:py-24 bg-cream-50">
      <div className="px-6 md:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20clean%20white%20desk%20with%20an%20open%20laptop%20showing%20a%20colorful%20organized%20spreadsheet%20full%20of%20product%20entries%2C%20next%20to%20it%20a%20notebook%20with%20handwritten%20italian%20notes%20and%20a%20ceramic%20mug%20of%20cappuccino%20with%20latte%20art%2C%20warm%20natural%20light%20from%20window%2C%20productive%20morning%20workspace%20vibe%2C%20authentic%20editorial%20photography&width=800&height=600&seq=seo-guide-preview-v2&orientation=landscape"
                alt="Itaobuy Spreadsheet guida completa"
                className="w-full"
              />
            </div>
          </div>

          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full bg-tealwarm-100 text-tealwarm-700 text-xs font-semibold uppercase tracking-wide mb-4">
              Guida SEO
            </span>
            <h2 className="font-display text-2xl md:text-4xl font-bold text-warm-950 leading-tight">
              <span className="text-tealwarm-600">Itaobuy Sheet:</span>{' '}
              La Guida Definitiva
            </h2>
            <p className="mt-4 text-sm md:text-base text-warm-600 leading-relaxed">
              <strong>Itaobuy spreadsheet</strong> è una raccolta organizzata di prodotti selezionati che permette agli utenti di trovare rapidamente articoli interessanti senza perdere ore nella ricerca manuale. Ogni spreadsheet può includere nome prodotto, categoria, prezzo, immagini QC, informazioni venditore e link diretti ai prodotti.
            </p>

            <div className="mt-6 overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-warm-200">
                    <th className="text-left py-3 pr-4 font-semibold text-warm-900 whitespace-nowrap">Caratteristica</th>
                    <th className="text-left py-3 pr-4 font-semibold text-tealwarm-700 whitespace-nowrap">
                      <i className="ri-checkbox-circle-fill mr-1"></i> Itaobuy Spreadsheet
                    </th>
                    <th className="text-left py-3 font-semibold text-warm-500 whitespace-nowrap">Ricerca Tradizionale</th>
                  </tr>
                </thead>
                <tbody className="text-warm-600">
                  <tr className="border-b border-warm-100">
                    <td className="py-2.5 pr-4">Prodotti selezionati</td>
                    <td className="py-2.5 pr-4 text-tealwarm-600"><i className="ri-check-line"></i></td>
                    <td className="py-2.5 text-warm-400"><i className="ri-close-line"></i></td>
                  </tr>
                  <tr className="border-b border-warm-100">
                    <td className="py-2.5 pr-4">Foto QC</td>
                    <td className="py-2.5 pr-4 text-tealwarm-600"><i className="ri-check-line"></i></td>
                    <td className="py-2.5 text-warm-400">Limitate</td>
                  </tr>
                  <tr className="border-b border-warm-100">
                    <td className="py-2.5 pr-4">Risparmio tempo</td>
                    <td className="py-2.5 pr-4 text-tealwarm-600">Alto</td>
                    <td className="py-2.5 text-warm-400">Basso</td>
                  </tr>
                  <tr className="border-b border-warm-100">
                    <td className="py-2.5 pr-4">Organizzazione</td>
                    <td className="py-2.5 pr-4 text-tealwarm-600">Professionale</td>
                    <td className="py-2.5 text-warm-400">Disordinata</td>
                  </tr>
                  <tr>
                    <td className="py-2.5 pr-4">Confronto prodotti</td>
                    <td className="py-2.5 pr-4 text-tealwarm-600">Facile</td>
                    <td className="py-2.5 text-warm-400">Difficile</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <Link
              to="/itaobuy-spreadsheet-guida-completa"
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-warm-900 text-white text-sm font-semibold hover:bg-warm-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Leggi la guida completa
              <i className="ri-arrow-right-up-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}